<a (click)="handleMainMenuAction()" class="nav-link borderB {{
        loginInfo.role === 'Super Admin' && isExpired ? 'disabled' : ''
    }}" [ngClass]="{active: isMainActive || isOneOfChildrenActive}">

    <img src={{menuItem.iconSRC}} alt="">
    <p [ngClass]="this.updatedtheme === 'dark' ? 'menuitemD' : 'menuitemL'" class="pl-2">
        {{ menuItem.name}}
        <!-- <i *ngIf="isExpandable && menuItem.children.length > 0" class="right fas fa-angle-right"
            [@rotate]="isMenuExtended"></i> -->
    </p>
</a>
<!-- <ul class="nav nav-treeview" *ngFor="let item of menuItem.children" [@openClose]="isMenuExtended">

    <li class="nav-item">
        <a [routerLink]="item.path"    ariaCurrentWhenActive="page" class="nav-link" [queryParams]="item.queryParams">
            <i class="nav-icon {{ item.iconClasses }}"></i>
            <p>{{ item.name }}</p>
        </a>
    </li>
</ul> -->

<!-- <ul
    class="nav nav-treeview"
    *ngFor="let item of menuItem.children"
    [@openClose]="isMenuExtended"
>
    <li class="nav-item">
        <a
            [routerLink]="item.path"
            [routerLinkActive]="'active'"
            class="nav-link"
        >
            <i class="nav-icon {{ item.iconClasses }}"></i>
            <p>{{ item.name }}</p>
        </a>
    </li>
</ul> -->